import "./Loader.css";

import logo from "../../Q8_logo.png";

const Loader = () => {
  return (
    <div className="background-loader">
      <div className="loader">
        <div className="circle"></div>
        <img src={logo} alt="Logo" className="logo" />
      </div>
    </div>
  );
};

export default Loader;
